import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Form,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import logo from "../assets/img/logo-dark.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendOtp } from "../api/authService";
import { sendOtpSchema } from "../validations/authSchema";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export default function ForgotPassword() {
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    resolver: yupResolver(sendOtpSchema)
  });


  const onSubmit = async (data) => {
    try { 
        const response = await sendOtp(data.email);
        if (response.status === 200) {
          toast.success("Email sent successfully");
          setSent(true);
          localStorage.setItem("email", data.email);
          reset();
          navigate("/otp");
        }
      } catch (error) {
        console.error("Error sending mail", error);
        toast.error("Failed to send email. Please try again.");
    }
  };

  return (
    <React.Fragment>
      <Row className="justify-content-center">
        <Col lg={6} className="loginform">
          <div className="loginmain_div maxwidth500 mx-auto">
            <div className="headlogin_div mb-4">
              <img className="loginlogo_img" src={logo} alt="logo" />
              <h2>Forgot Password</h2>
              <p>Please enter your email address to receive an OTP for password reset.</p>
            </div>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="mb-4 form-group">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email address"
                  {...register("email")}
                />
                {errors.email && (
                  <p className="text-danger">{errors.email.message}</p>
                )}
              </Form.Group>
              {sent && <p className="text-success">OTP sent to your email.</p>}
              <Button type="submit" className="btn btn-primary w-100 mt-3">Proceed</Button>
              <p className="formfooter text-center mt-3">
                Back To <Link to="/">Login</Link>
              </p>
            </Form>
          </div>
        </Col>
      </Row>
      <ToastContainer />
    </React.Fragment>
  );
}
